module.exports = __webpack_public_path__ + "img/sensor-triangle-exclamation.99dfc5ad.svg";